import {
  navigationRequested,
  navigationCompleted,
} from '@wix/bi-logger-podcast/v2';
import router, { RouterEvent } from '../lib/router/router';

import stringifyError from '../lib/utils/stringifyError';

import { biLogger, biTransaction } from './bi';
import { BiEvent } from '../lib/bi/types';
import { WidgetPage } from '@wix/podcasts-common/dist/widget';

function syncRouterWithBILogger() {
  const unsubscribeChangeStarted = router.on(
    RouterEvent.ROUTE_CHANGE_STARTED,
    ({ route }) => {
      biLogger.report(
        navigationRequested({
          correlationId: biTransaction.start(BiEvent.NAVIGATION_REQUESTED).id,
          pageType: route.page,
          episodeId:
            route.page === WidgetPage.EPISODE ? route.params.id : undefined,
        }),
      );
    },
  );

  const unsubscribeChangeCompleted = router.on(
    RouterEvent.ROUTE_CHANGE_COMPLETED,
    ({ route, routeError }) => {
      biLogger.report(
        navigationCompleted({
          correlationId: biTransaction.end(BiEvent.NAVIGATION_COMPLETED).id,
          pageType: route.page,
          episodeId:
            route.page === WidgetPage.EPISODE ? route.params.id : undefined,
          errorType: stringifyError(routeError),
        }),
      );
    },
  );

  return () => {
    unsubscribeChangeStarted();
    unsubscribeChangeCompleted();
  };
}

export default syncRouterWithBILogger;
